import React, { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

function EggShellStudio() {
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="w-full sm:w-3/4 2xl:w-2/3 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:mt-16">
                  <Swiper pagination={true} modules={[Pagination]} className="mySwiper">
                    <SwiperSlide>
                      <div className="Close flex justify-between items-center">
                        <div className="PageHeading font-semibold text-xl sm:text-2xl ps-6">
                          <h1 className='text-lg md:text-2xl'><span>EggShell-Studio</span> - Webiste View on PC</h1>
                        </div>
                        <div className="Close">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" onClick={() => setOpen(false)} className="w-9 h-9 m-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                          </svg>
                        </div>
                      </div>
                      <div className="Dialog h-[30rem] px-1 pb-4 pt-4 sm:p-6 sm:pb-4">
                        <div className="VideoContainer w-full h-full mb-4 pb-6">
                          <iframe className='w-full h-full' src="https://www.youtube.com/embed/kAZEMe0c1vc?si=nOXngsKqNyqVCCe9&rel=0" title="WebDev" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowFullScreen></iframe>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="Close flex justify-between items-center">
                        <div className="PageHeading font-semibold ps-6">
                          <h1 className='text-lg md:text-2xl'><span>EggShell-Studio</span> - Webiste View on Mobile</h1>
                        </div>
                        <div className="Close">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" onClick={() => setOpen(false)} className="w-9 h-9 m-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                          </svg>
                        </div>
                      </div>
                      <div className="Dialog h-[30rem] px-1 pb-4 pt-4 sm:p-6 sm:pb-4">
                        <div className="VideoContainer w-full h-full mb-4 pb-6">
                          <iframe className='w-full h-full' src="https://www.youtube.com/embed/kAZEMe0c1vc?si=nOXngsKqNyqVCCe9&rel=0" title="WebDev" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowFullScreen></iframe>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export default EggShellStudio;
